export const firstLetterUpperCase = (value) => {
    const finalString = value.charAt(0).toUpperCase() + value.slice(1)
    return finalString.toString();
}